import { gtagService } from "../service/gtag";

const analytics = {
    namespaced: true,
    state: {

    },
    mutations: {
        trackGtagProductListing: (state, data) => {
            gtagService.do('event', 'view_item_list', data);
        },
        trackGtagAddToCart: (state, data) => {
            gtagService.do('event', 'add_to_cart', {
                list_name: data.list,
                list_position: data.position,
                affiliation: data.affiliation,
                coupon: data.voucher,
                items: [data]
            });
        },
        trackGtagRemoveFromCart: (state, data) => {
            gtagService.do('event', 'remove_from_cart', {
                list_name: data.list,
                list_position: data.position,
                affiliation: data.affiliation,
                coupon: data.voucher,
                items: [data]
            });
        },
        trackGtagClearCart: (state, data) => {
            gtagService.do('event', 'remove_from_cart', {
                list_name: data.list,
                list_position: data.position,
                affiliation: data.affiliation,
                coupon: data.voucher,
                items: data
            });
        },
        trackGtagCheckoutProgress: (state, data) => {
            gtagService.do('event', 'checkout_progress', {
                list_name: data.list,
                list_position: data.position,
                affiliation: data.affiliation,
                coupon: data.voucher,
                items: data
            });
        },
        trackGtagSelectProduct: (state, data) => {
            gtagService.do('event', 'select_content', {
                list_name: data.list,
                list_position: data.position,
                affiliation: data.affiliation,
                coupon: data.voucher,
                "content_type": "product",
                items: data
            });
        },
        trackGtagViewPromotion: (state, data) => {
            gtagService.do('event', 'select_promotion', data);
            gtagService.do('event', 'select_content', {
                promotions: [{ name: data.label }]
            });
        },
        setGAMealPlan: (state, data) => {
            gtag('event', 'set_meal_plan', { 'meal_plan': data.toLowerCase(), 'non_interaction': true });
        },
        setGAPeople: (state, data) => {
            gtag('event', 'set_people', { 'people': data, 'non_interaction': true });
        }
    },
    actions: {
        trackProductListing: ({ commit }, data) => {
            commit('trackGtagProductListing', data);
        },
        trackAddToCart: ({ commit }, data) => {
            commit('trackGtagAddToCart', data);
        },
        trackRemoveFromCart: ({ commit }, data) => {
            commit('trackGtagRemoveFromCart', data);
        },
        trackClearCart: ({ commit }, data) => {
            commit('trackGtagClearCart', data);
        },
        trackCheckoutProgress: ({ commit }, data) => {
            commit('trackGtagCheckoutProgress', data);
        },
        trackSelectProduct: ({ commit }, data) => {
            commit('trackGtagSelectProduct', data);
        },
        trackSelectPromotion: ({ commit }, data) => {
            commit('trackGtagViewPromotion', data);
        },
        setGAMealPlan: ({ commit }, data) => {
            commit('setGAMealPlan', data);
        },
        setGAPeople: ({ commit }, data) => {
            commit('setGAPeople', data);
        },
    }
}

export default analytics